export default {"src":"/_next/static/media/light-purple-left.d76a5f18.svg","height":280,"width":1920,"blurWidth":0,"blurHeight":0};